<div style="margin-top: 10px; display: flex; gap: 8px">
  <div class="notificaciones-container" [class.dark]="modoOscuro">
    <div class="header">
      <div class="header-title">
        <h2>Notificaciones</h2>
      </div>
      <div class="header-actions">
        <div class="push-toggle-small">
          <label class="toggle-switch-small">
            <input
              type="checkbox"
              [checked]="notificacionesPushActivas"
              (change)="toggleNotificacionesPush($event)"
            />
            <span class="toggle-slider-small"></span>
          </label>
          <lucide-angular
            [img]="notificacionesPushActivas ? icons.BellRing : icons.BellOff"
            [size]="14"
            [strokeWidth]="1.5"
            class="toggle-icon"
          >
          </lucide-angular>
        </div>

        <button
          class="btn-marcar-todas"
          *ngIf="getUnreadCount() > 0"
          (click)="marcarTodasComoLeidas()"
          aria-label="Marcar todas como leídas"
        >
          <lucide-angular
            [img]="icons.CheckCircle"
            [size]="18"
            [strokeWidth]="1.5"
          ></lucide-angular>
          Leer Todas
        </button>
      </div>
    </div>

    <div
      class="notificaciones-lista"
      [class.has-scroll]="notificaciones.length > maxNotificacionesVisibles"
    >
      @for (notificacion of notificaciones; track notificacion.id) {
        <div
          class="notificacion-item"
          [class.no-leida]="!notificacion.leida"
          [class.success]="notificacion.tipo === 'success'"
          [class.info]="notificacion.tipo === 'info'"
          [class.warning]="notificacion.tipo === 'warning'"
          [class.error]="notificacion.tipo === 'error'"
          (click)="marcarComoLeida(notificacion.id)"
          (keydown.enter)="marcarComoLeida(notificacion.id)"
          tabindex="0"
        >
          <div class="notificacion-icono">
            <lucide-angular
              [img]="getIconoPorTipo(notificacion.tipo)"
              [size]="20"
              [strokeWidth]="1.5"
            >
            </lucide-angular>
          </div>

          <div class="notificacion-contenido">
            <div class="notificacion-titulo">
              {{ truncarTexto(notificacion.titulo, 50) }}
            </div>
            <div class="notificacion-mensaje">
              {{ truncarTexto(notificacion.mensaje, 250) }}
            </div>
            <div class="notificacion-fecha">
              {{ formatFecha(notificacion.fecha) }}
            </div>
          </div>

          @if (!notificacion.leida) {
            <div class="notificacion-no-leida-indicador">
              <span class="punto-no-leido"></span>
            </div>
          }
        </div>
      } @empty {
        <div class="empty-state">
          <div class="empty-icon">
            <lucide-angular [img]="icons.Bell" [size]="48" [strokeWidth]="1.5"></lucide-angular>
          </div>
          <p>No hay notificaciones</p>
          <span>Todas tus notificaciones aparecerán aquí</span>
        </div>
      }
    </div>
  </div>
</div>
